import AccountContainer from "./AccountContainer";
import AccountStore from "./AccountStore";

export default AccountStore(AccountContainer);